<!--抗衰资产明细-->
<template>
    <div class="customerList-module">
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索名称/编号"
                left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div class="select-box flex-y-center flex-between">
            <div class="add-customer">
                <span>项目总额：</span>
                <span class="add-customer-number">{{totalServiceBalanceAmount}}</span>
                <span>万</span>
                <span class="sheets">总次数：</span>
                <span class="add-customer-number">{{totalServiceCount}}</span>
            </div>
            <div class="select-item flex-between flex-y-center" @click="selectSortPopup">
                <div class="select-tit">{{ checkedSort && checkedSort.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div>

        <div class="list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" :offset="200"
                    @load="getList" :immediate-check="false">
                    <div v-if="serviceList.length > 0 ">
                        <!-- 下拉刷新 -->
                        <div class="customer-list" v-for="(item, index) in serviceList" :key="index"
                            @click="toDetail(item.serviceSku,item.serviceName)">
                            <div class="flex-y-center">
                                <div class="customer-info flex-1">
                                    {{item.serviceName}}
                                </div>
                                <img class="arrow_right" referrerpolicy="no-referrer"
                                    src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" />
                            </div>
                            <div class="customer-remark flex-between flex-y-center">
                                <div class="flex-between flex-y-center">
                                    <span class="sale-name">资产：</span>
                                    <span class="sale-number">{{item.servicePropertyAmount}}万</span>
                                </div>
                                <div class="flex-between flex-y-center">
                                    <span class="sale-name">次数：</span>
                                    <span class="sale-number">{{item.serviceCount}}</span>
                                </div>
                                <div class="flex-between flex-y-center">
                                    <span class="sale-name">持有顾客数：</span>
                                    <span class="sale-number">{{item.customerCount}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
        <van-popup v-model="showSortPopup" round position="bottom" closeable class="popup">
            <picker title="排序" v-model="checkedSort" :list="sortList" @change="onSortChange"></picker>
        </van-popup>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Search, Toast } from "vant";
import Picker from '@/components/Picker';

export default {
    name: "ksAssetList",
    components: {
        [Search.name]: Search, Picker
    },
    data() {
        return {
            totalServiceBalanceAmount: 0,   //总额
            totalServiceCount: 0,    //总次数
            serviceList: [],    // 列表
            refreshing: false,   // 刷新
            dimension: 0, //区分生美医美 1 生美 2 医美
            type: '', // 项目类型
            loading: false,
            finished: false,
            page: 1,
            limit: 10,
            searchStr: '',  // 搜索条件
            sortList: [], // 排序
            checkedSort: null,//所选排序
            showSortPopup: false,   //筛选弹出框   
        };
    },
    computed: {
    },
    mounted() {
        this.dimension = JSON.parse(localStorage.getItem('employeeInfo')).dimension
        this.type = this.$route.query.type
        this.init()
        document.title = (this.type == 1 ? '功能' : this.type == 2 ? '再生' : this.type == 3 ? '女性特护' : this.type == 4 ? '券余' : '') + '资产明细'

    },
    methods: {
        async init() {
            await this.getSortList()
            this.getList()
        },
        getList() {
            this.loading = true
            let url = '/debt/storeServiceProperty' // 护理请求
            if (this.type == 4) {
                url = '/debt/storeCouponProperty' // 券余请求
            }
            let params = {
                propertySortType: this.checkedSort.id,
                limit: this.limit,
                page: this.page,
                id: this.$route.query.id || '',
                storeId: this.$route.query.storeId || '',
                cateType: this.type,
                searchStr: this.searchStr,
            }
            return request({
                url: url,
                method: "get",
                params: params
            })
                .then((res) => {
                    this.totalAmountList = res.data;
                    this.serviceList = this.page == 1 ? res.data.servicePropertyPage.list : this.serviceList.concat(res.data.servicePropertyPage.list);
                    this.page += 1;
                    this.total = res.data.servicePropertyPage.total;
                    this.totalServiceBalanceAmount = res.data.totalServiceBalanceAmount;
                    this.totalServiceCount = res.data.totalServiceCount;
                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    this.refreshing = false;
                    if (this.serviceList.length >= this.total) {
                        this.finished = true;
                    }
                });
        },
        onRefresh() {
            this.page = 1
            this.finished = false;
            this.newCardList = [];
            this.refreshing = false;
            this.getList();
        },
        //查看详情
        toDetail(serviceSku, serviceName) {
            this.$router.push({
                name: "ksAssetItem", query: {
                    type: this.type,
                    serviceSku: serviceSku,
                    serviceName: serviceName,
                    id: this.$route.query.id,
                    storeId: this.$route.query.storeId
                }
            });
        },
        // 获取排序
        getSortList() {
            return request({
                url: "/debt/cardCustomerSortList",
                method: "get",
            })
                .then((res) => {
                    this.sortList = res.data
                    this.checkedSort = this.sortList[0] //默认全部

                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 弹窗
        selectSortPopup() {
            this.showSortPopup = true
        },
        onSortChange(data) {
            console.log(data);
            this.showSortPopup = false
            this.checkedSort = data
            console.log(this.checkedSort);
            this.onRefresh()
        },
        //搜索
        onSearch() {
            this.page = 1
            this.getList();
        },
        //清除搜索
        selClear() {
            this.searchStr = "";
            this.onRefresh()
        },
    },
};
</script>

<style scoped lang="less">
::-webkit-scrollbar {
    display: none;
}
.mr-30 {
    margin-right: 30px;
}
.add-customer {
    font-weight: 400;
    color: #66757f;
    font-size: 26px;
    line-height: 37px;
    margin: 0;
}
.customer-info {
    height: 42px;
    font-size: 30px;
    font-weight: 700;
    color: #35434c;
    line-height: 42px;
    margin-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.sheets {
    margin-left: 30px;
}
.add-customer-number {
    color: #f65252;
    font-weight: 700;
    font-size: 30px;
}

.list-box {
    width: 100%;
    height: calc(100vh - 145px);
    justify-content: space-between;
    margin: 0 auto 0;
    position: relative;
    z-index: 1;
    overflow-y: auto;
    padding: 0 30px 30px 30px;
}

.customer-list {
    width: 690px;
    height: 172px;
    background: #fafafe;
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
}
.customer-name {
    min-width: 60px;
    height: 42px;
    font-size: 30px;
    color: #35434c;
    line-height: 42px;
    font-weight: 700;
}
.churn-time {
    height: 37px;
    font-size: 26px;
    color: #a0acb5;
    line-height: 37px;
    margin-top: 11px;
}
.nursing-edit-box {
    margin: 37px 0 0 163px;
}
.arrow_right {
    width: 15px;
    height: 26px;
}

.card-image {
    height: 34px;
    width: 90px;
    margin: 24px 0 0 10px;
}
.customerHeadPortrait {
    width: 90px;
    height: 90px;
    border-radius: 45px;
}
.customer-remark {
    padding: 30px 0 30px 0;
}
.sale-name {
    height: 40px;
    font-size: 28px;
    color: #a0acb5;
    line-height: 40px;
}
.sale-number {
    height: 40px;
    font-size: 28px;
    font-weight: 700;
    color: #35434c;
    line-height: 40px;
}
.empty-icon {
    width: 280px;
    height: 280px;
    margin-top: 179px;
}

.empty-txt {
    font-size: 30px;
    color: #a0acb5;
}
.select-box {
    padding: 0 30px 40px 31px;
    .select-tit {
        font-size: 28px;
        color: #35434c;
    }
    .select-arrow {
        transform: rotate(90deg);
        font-size: 24px;
        margin-left: 10px;
    }
}
:deep(.search-button.van-search) {
    padding: 30px 30px 30px 30px;
}
:deep(.search-button .van-icon) {
    font-size: 28px;
}
:deep(.search-button .van-search__content) {
    padding-left: 28px !important;
}
:deep(.search-button .van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 3px 20px 0 0 !important;
    margin-right: 0 !important;
}
:deep(.van-field__control) {
    font-size: 28px !important;
}
:deep(.van-icon__image) {
    height: 28px;
    display: inline-block;
}
</style>

